import { displayStringFromFHIRBoolean } from "../../datatypeComponents/BooleanEntry";
import { displayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import { displayStringFromFHIRRange } from "../../datatypeComponents/RangeEntry";
import { displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";

const generateNarrativeForGroupResource = (resource) => {
    let status = "generated";
    let innerDiv = "";
    try {
        if (resource.title) {
            innerDiv += "<p><b>Title: </b>" + resource.title + "</p>";
        }
        if (resource.name) {
            innerDiv += "<p><b>Name: </b>" + resource.name + "</p>";
        }
        if (resource.type && typeof resource.type === "string") {
            innerDiv += "<p><b>Type: </b>" + resource.type + "</p>";
        }
        if (resource.code) {
            innerDiv += "<p><b>Kind: </b>" + displayStringFromFHIRCodeableConcept(resource.code) + "</p>";
        }
        if (resource.membership) {
            innerDiv += "<p><b>Membership/Definitional: </b>" + resource.membership + "</p>";
        }
        if (resource.quantity) {
            innerDiv += "<p><b>Quantity: </b>" + resource.quantity + "</p>";
        }
        if (resource.description) {
            innerDiv += "<p><b>Description: </b>" + resource.description + "</p>";
        }
        if (resource.managingEntity) {
            innerDiv += "<p><b>Managing Entity: </b>" + displayStringFromFHIRReference(resource.managingEntity) + "</p>";
        }
        let characteristicExpression;
        if (Array.isArray(resource.extension)) {
            for (let extension of resource.extension) {
                if (extension.url === "http://hl7.org/fhir/StructureDefinition/characteristicExpression") {
                    characteristicExpression = extension.valueExpression;
                }
            }
        }
        if (characteristicExpression) {
            status = "extensions";
            if (characteristicExpression.name) {
                innerDiv += "<p><b>Defined by Expression Named: </b>" + characteristicExpression.name + "</p>";
            }
            if (characteristicExpression.description) {
                innerDiv += "<p><b>Defined by Expression: </b>" + characteristicExpression.description + "</p>";
            }
            if (characteristicExpression.language) {
                innerDiv += "<p><b>Defined by Expression in Language: </b>" + characteristicExpression.language + "</p>";
            }
            if (characteristicExpression.expression) {
                innerDiv += "<p><b>Defined by Expression: </b>" + characteristicExpression.expression + "</p>";
            }
            if (characteristicExpression.reference) {
                innerDiv += "<p><b>Defined by Expression at URL: </b>" + characteristicExpression.reference + "</p>";
            }
        }
        if (resource.combinationMethod) {
            innerDiv += "<p><b>Combination Method: </b>" + resource.combinationMethod + "</p>";
        }
        if (resource.combinationThreshold) {
            innerDiv += "<p><b>Number of characteristics: </b>" + resource.combinationThreshold + "</p>";
        }
        if (resource.characteristic?.length > 0) {
            innerDiv += resource.characteristic.map((item) => {
                let description = item.description || "";
                let code = displayStringFromFHIRCodeableConcept(item.code) || "";
                let categoryValue = "";
                if (item.valueCodeableConcept) {
                    categoryValue = displayStringFromFHIRCodeableConcept(item.valueCodeableConcept);
                } else if (item.valueQuantity) {
                    categoryValue = displayStringFromFHIRQuantity(item.valueQuantity);
                } else if (item.valueRange) {
                    categoryValue = displayStringFromFHIRRange(item.valueRange);
                } else if (item.valueReference) {
                    categoryValue = displayStringFromFHIRReference(item.valueReference);
                } else if (item.valueBoolean) {
                    categoryValue = displayStringFromFHIRBoolean(item.valueBoolean);
                } else if (item.valueUri) {
                    categoryValue = item.valueUri;
                } else if (item.valueExpression) {
                    categoryValue = "[Defined by Expression]";
                }
                if (description) {
                    return "<p><b>Characteristic: </b>" + description + "; <b>Defined as: </b>" + code + " matching value of " + categoryValue + "</p>"
                } else {
                    return "<p><b>Characteristic: </b>" + code + " matching value of " + categoryValue + "</p>"
                }
            }).join("");
        }
        if (resource.member?.length > 0) {
            innerDiv += resource.member.map((member) => {
                return "<p><b>Member: </b>" + displayStringFromFHIRReference(member.entity) + "</p>"
            }).join("");
        }
    } catch {
        innerDiv = "[Unable to generate Narrative Summary.]"
    }
    return { "status": status, "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">" + innerDiv + "</div>" };
};

export default generateNarrativeForGroupResource;